import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import Page from '@/components/content/Page'

import Error from './feedback/Error'
import LoaderCircle from './LoaderCircle'

const InitialLoadWrapper = ({
  loadingSelector,
  loadedSelector,
  errorSelector,
  loadAction,
  args,
  forceLoadOnMount,
  children,
}: any) => {
  const isLoading = useSelector(loadingSelector)
  const isLoaded = useSelector(loadedSelector)
  const error = useSelector(errorSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    if ((!isLoading && !isLoaded) || forceLoadOnMount) {
      dispatch(loadAction(args))
    }
  }, [])

  if (error) {
    // @ts-ignore
    return <Error textId={error} />
  }

  if (!isLoaded) {
    return (
      <Page className="initial-load-wrapper">
        <LoaderCircle />
      </Page>
    )
  }

  return children
}

export default InitialLoadWrapper
